import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
@Component({
  selector: 'app-add-b1',
  templateUrl: './add-b1.component.html',
  styleUrl: './add-b1.component.css'
})
export class AddB1Component implements OnInit {
  b1Form: FormGroup;
 optionsMap: { [key: string]: any[] } = {
    countries: [{ value: 'India', label: 'India' }],
    states: [],
    districts: [],
    subDistricts: [],
    villages: [],
  };
  B1FormFields = [
    { key: 'clientName', label: 'Client Name', type: 'text', value: '' },
    { key: 'contactPerson', label: 'Contact Person', type: 'text', value: '' },
    { key: 'contactNo', label: 'Contact No', type: 'text', value: '' },
    { key: 'COUNTRY', label: 'Country', type: 'select', value: '', optionKey: 'countries', onChange: () => this.onCountryStateChange(), required: true },
    { key: 'state', label: 'State', type: 'select', value: '', optionKey: 'states', onChange: () => this.onStateChange(), required: true },
    { key: 'district', label: 'District', type: 'select', value: '', optionKey: 'districts', onChange: () => this.onStatedistrictsChange(), required: true },
    { key: 'tehsil', label: 'Tehsil', type: 'select', value: '', optionKey: 'subDistricts', onChange: () => this.onStatedistrictssubDistrictsChange(), required: true },
    { key: 'village', label: 'Village', type: 'select', value: '', optionKey: 'villages', required: true },
    { key: 'khasraNo', label: 'Khasra No', type: 'text', value: '' },
    { key: 'area', label: 'Area', type: 'text', value: '' },
    { key: 'entryDate', label: 'Entry Date', type: 'date', value: '' },
    { key: 'category', label: 'Category', type: 'text', value: '' },
    { key: 'ecMepStatus', label: 'EC/MEP Status', type: 'text', value: '' },
    { key: 'mpPlanPeriod', label: 'MP Plan Period', type: 'text', value: '' },
    { key: 'blastStatus', label: 'Blast/Non-Blast', type: 'text', value: '' },
    { key: 'mineral', label: 'Mineral', type: 'text', value: '' },
    { key: 'fileStatus', label: 'File Status', type: 'text', value: '' },
    { key: 'filePreparedBy', label: 'File Prepared By', type: 'text', value: '' },
    { key: 'productionDetails', label: 'Production Details', type: 'text', value: '' },
    { key: 'torOnlineDate', label: 'TOR Online Date', type: 'date', value: '' },
    { key: 'proposalNo', label: 'Proposal No', type: 'text', value: '' },
    { key: 'caseNo', label: 'Case No', type: 'text', value: '' },
    { key: 'torSEACDate', label: 'TOR SEAC Date', type: 'date', value: '' },
    { key: 'pptStatus', label: 'PPT Status', type: 'text', value: '' },
    { key: 'torSEACMinutes', label: 'TOR SEAC Minutes', type: 'text', value: '' },
    { key: 'seiaAgendaDate', label: 'SEIAA Agenda Date', type: 'date', value: '' },
    { key: 'pptStatusApproved', label: 'PPT Status Approved', type: 'text', value: '' },
    { key: 'seiaMinutes', label: 'SEIAA Minutes', type: 'text', value: '' },
    { key: 'remark', label: 'Remark', type: 'textarea', value: '' },
    { key: 'torGranted', label: 'TOR Granted', type: 'text', value: '' },
    { key: 'dd', label: 'DD', type: 'text', value: '' },
    { key: 'draftEIADate', label: 'Draft EIA Date', type: 'date', value: '' },
    { key: 'reportSentToRoPcb', label: 'Report Sent to RO/PCB', type: 'date', value: '' },
    { key: 'phDate', label: 'PH Date', type: 'date', value: '' },
    { key: 'newsPublished', label: 'News Published', type: 'text', value: '' },
    { key: 'ecStatus', label: 'EC Status', type: 'text', value: '' },
    { key: 'hyperlink', label: 'Hyperlink', type: 'text', value: '' },
    { key: 'kni', label: 'KNI', type: 'text', value: '' },
    { key: 'remark2', label: 'Remark 2', type: 'textarea', value: '' },
    { key: 'infoRedrafted', label: 'Info Redrafted', type: 'text', value: '' },
    { key: 'minutesPrepared', label: 'Minutes Prepared', type: 'text', value: '' },
    { key: 'finalMinutes', label: 'Final Minutes', type: 'text', value: '' },
    { key: 'finalEIAReport', label: 'Final EIA Report', type: 'text', value: '' },
    { key: 'finalEIASEACAgenda', label: 'Final EIA SEAC Agenda', type: 'text', value: '' },
    { key: 'finalEIASEACMinutes', label: 'Final EIA SEAC Minutes', type: 'text', value: '' },
    { key: 'finalEIASEIAAgenda', label: 'Final EIA SEIAA Agenda', type: 'text', value: '' },
    { key: 'finalEIASEIAMinutes', label: 'Final EIA SEIAA Minutes', type: 'text', value: '' },
    { key: 'finalEC', label: 'Final EC', type: 'text', value: '' },
    { key: 'followup', label: 'Follow-up', type: 'text', value: '' },
    { key: 'currentStatus', label: 'Current Status', type: 'text', value: '' },
    { key: 'presentStatus', label: 'Present Status', type: 'text', value: '' },
    { key: 'nextFollowupDate', label: 'Next Follow-up Date', type: 'date', value: '' },
    { key: 'hyperlinkFolder2', label: 'Hyperlink Folder 2', type: 'text', value: '' },
    { key: 'kni2', label: 'KNI 2', type: 'text', value: '' },
    { key: 'remark3', label: 'Remark 3', type: 'textarea', value: '' }
  ];
pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) {}

  ngOnInit(): void {
    const formGroupConfig :any = {};
    this.B1FormFields.forEach(field => formGroupConfig[field.key] = ['']);
    this.b1Form = this.fb.group(formGroupConfig);
  }

    onCountryStateChange() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.optionsMap['states'] = (res as any[]).map(state => ({
          value: state,
          label: state
        }));
        this.b1Form.get('state')?.setValue('');
        this.optionsMap['districts'] = [];
      },
      error: (err) => this.toastrMsgService.error(err.error.errorMessage)
    });
  }

  onStateChange() {
    const selectedState = this.b1Form.get('state')?.value;
    console.log(selectedState)
    if (selectedState) {
      this.apiService.getdistricts(selectedState).subscribe({
        next: (res) => {
          this.optionsMap['districts'] = (res as any[]).map(city => ({
            value: city,
            label: city
          }));
          this.b1Form.get('district')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }
  }
  onStatedistrictsChange() {
    const state = this.b1Form.value.state;
    const district = this.b1Form.value.district;
     if (district) {
      this.apiService.getSubdistricts(state,district).subscribe({
        next: (res) => {
          this.optionsMap['subDistricts'] = (res as any[]).map(subDis => ({
            value: subDis,
            label: subDis
          }));
          this.b1Form.get('tehsil')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }

  }
  onStatedistrictssubDistrictsChange() {
      const state = this.b1Form.value.state;
    const district = this.b1Form.value.district;
    const subdistrict = this.b1Form.value.tehsil;
     if (subdistrict) {
      this.apiService.getvillages(state,district,subdistrict).subscribe({
        next: (res) => {
          this.optionsMap['villages'] = (res as any[]).map(vill => ({
            value: vill,
            label: vill
          }));
          this.b1Form.get('village')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }

  }

  onSubmit(): void {
    if (this.b1Form.valid) {
      console.log('Form Submitted:', this.b1Form.value);
    }
  }

  onReset(): void {
    this.b1Form.reset();
  }
}